// extracted by mini-css-extract-plugin
var _1 = "active-N_h3Y";
var _2 = "discount-Nsejk";
var _3 = "label-kPZ9m";
var _4 = "throw-t2UAj";
var _5 = "variant-oaq5d";
var _6 = "wrapper-HjlWX";
export { _1 as "active", _2 as "discount", _3 as "label", _4 as "throw", _5 as "variant", _6 as "wrapper" }
